<template>
  <div class="app" @mousemove="resetTimer" @touchstart="resetTimer">
    <router-view>
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    /*return {
      idleTimeout: null
    }*/
  },
  mounted() {
    //this.startTimer()
  },
  methods: {
    /*startTimer() {
      this.idleTimeout = setTimeout(() => {
        this.$router.push('/screensaver')
      }, 900000) // Tiempo en milisegundos (900 segundos)
    },
    resetTimer() {
      clearTimeout(this.idleTimeout)
      this.startTimer()
    }*/
  }
}
</script>

<style scoped>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

</style>
